import TableComponent from "../../../Table/Table";
import TableComponentPage4 from '../../../Table/GroupTable';
import "./AffiliateSites.css"
import { Button, Form, Spinner } from 'react-bootstrap'
import React, { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom'
import axios from 'axios';
import Select from 'react-select'
import { Input } from 'rsuite'
import toast, { Toaster } from 'react-hot-toast';

export default function PayBonus() {
    const [searchParams] = useSearchParams();
    const AffiliateID = searchParams.get('id');
    const [websites, setWebsites] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [bonus, setBonus] = useState({
        description: "",
        amount: ""
    })
    const [resetTable, setResetTable] = useState(false);
    const [bonusLoading, setBonusLoading] = useState(false);
    const [affiliate, setAffiliate] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pages, setPages] = useState(0);

    const getWebsites = async () => {
        setLoading(true)
        const response = await axios.get(window.__CFG.API + "affiliates/GetWebsites/" + AffiliateID, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLoading(false)
            setWebsites(response.data.Result)
        }
    }

    const getAffiliateById = async () => {
        const response = await axios.get(window.__CFG.API + "affiliates/GetAffiliate/" + AffiliateID, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setAffiliate(response.data.Result);
            setPages(response.data.Pages);
        }
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'Id',
            },
            {
                Header: 'Website',
                accessor: 'Website',
            }
        ],
        []
    );
    useEffect(() => { getWebsites(); getAffiliateById(); }, [])
    const optionsCurrency = [{ label: "USD", value: 1 }]
    const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

    const handleSelectedRowsChange = (selectedRows) => {
        setSelectedRows(selectedRows);
    }

    return (
        <>
            <div className="page-aff-wp">
                <div className="page-aff-ttl">
                    Affiliate Websites
                </div>
                <div className="page-aff">
                    <div className="page-aff-nm">
                        Affiliate: {affiliate?.Username}
                    </div>
                    <div className="page-aff-tb">
                        <div className="aff-dash-summary-table">
                        <TableComponentPage4 showCheckbox={false} key={resetTable} columns={columns} data={websites} onSelectedRowsChange={handleSelectedRowsChange} Pages={pages} currentPage={page} onPageChange={setPage} loading={loading} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}